import { getErrorMessage } from './error-formatter';

// This function is to move away from try-catch nesting issue
// so far try-catch, and throw are being used for flow control
// which is not good practice

// usage with legacy code: (error is handled in a function callback)
// const [, createdWkExportEntity] = await useCatch(yourPromise, { throw: true, onError: ()=>{} })

// usage with new code: (error is dealt with separately)
// const [error, varName] = await useCatch(yourPromise)
// and then handle the error

export async function useCatch<T>(
  promise: Promise<T>,
  options: { throw?: boolean; onError?: (message: string) => void } = {},
): Promise<[Error] | [undefined, T]> {
  return promise
    .then((data) => [undefined, data] as [undefined, T])
    .catch((error) => {
      if (options.onError) {
        const errorMessage = getErrorMessage(error);
        options.onError(errorMessage);
      }

      if (options.throw) {
        throw error;
      }

      return [error];
    });
}
